import React from 'react';
import {
    Text, View, Image, TextInput,
    ActivityIndicator, Pressable, FlatList
} from 'react-native';
import { debounce } from "lodash";
import { store } from '../../store/store';

import { getImagePath } from '../../utils/services/CommonUtils';
import { getCartTotalItemCount } from '../../utils/services/oms/UpsertCartData';
import { doPost as omsDoPost, doPostGuest as omsDoPostGuest } from '../../utils/services/api/OMSAPI';
import { calculateCartAmount, getCartItemFroRedux, mergeMedicineWithCartData, upsertCartItem } from '../../utils/services/oms/OMSCartUtils';

import { CartItemView } from '../../utils/widgets/CartItemView';
import { CartIconView } from '../../utils/widgets/CommonWidget/CartIconView';
import { EstimatedPriceView } from '../../utils/widgets/cart/EstimatedPriceBottomSheet';
import { AutoColorTypedStringView, CloseIcon, CommonBackIcon, HorizontalDivider } from '../../utils/widgets/Common-Widget';

import { NavigateFrom, ScreenRoute } from '../../utils/constants/ScreenRouteConstant';

import AppTheme from '../../AppTheme';
import AppStyles from '../../AppStyles';
import TextStyle from '../../TextStyle';

import AddCartItemToast from '../../utils/modals/AddCartItemToast';
import CartQuantityInputBottomSheet from '../../utils/modals/CartQuantityBottomSheet';

import * as MoengageUtils from '../../utils/services/webapp-services/MoengageUtils';

export default class SearchMedicineComponent extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {

            isLogined: store.getState().isUserLogin ?? false,

            searchWord: '',
            searchedMeds: [],

            stripList: [],
            searchWordResult: [],

            prevSearchResult: [],

            showSearchingLoader: false,
            showTypedMedicineName: false,

            cartItems: [],

            showQtyModel: false,
            selectedProductData: {},

            showCartItemToast: false
        };
    }

    componentDidMount() {
        // this.checkAndUpdatePreviousSelectedMed()
        // const { navigation }: any = this.props;
        // navigation.addListener("focus", () => {
        //     this.checkAndUpdatePreviousSelectedMed()
        // });

        this.cartDataSubscription()
        store.subscribe(() => this.cartDataSubscription())
    }

    cartDataSubscription = debounce(this.setCartData, AppTheme.debouceTimeout)

    setCartData() {
        let cartItems = getCartItemFroRedux()
        this.setState({ cartItems: cartItems })
        let searchedMedicineList = mergeMedicineWithCartData({
            medicines: this.state.searchedMeds, cartItemsList: cartItems,
            retainTypeMedicine: this.state.searchWord.length > 0,
            typeMedicineName: this.state.searchWord
        })
        this.setState({ searchedMeds: searchedMedicineList });
    }

    checkAndUpdatePreviousSelectedMed() {
        // keeping it, for future changes.
        const reduxState = store.getState()
        if (reduxState.previousSelectedMedicineCategory.length) {
            var list: any = reduxState.previousSelectedMedicineCategory
            this.setState({ prevSearchResult: list, searchWordResult: list })
        }
    }

    setSearchedMedcineList(searchWord, response) {
        if (!response) {
            this.handleErrState(); return;
        }
        if (searchWord.includes(response.searchWord) ||
            response.searchWord.includes(searchWord)) {
            let medicineList = []
            if (response.results)
                medicineList = mergeMedicineWithCartData({
                    medicines: response.results,
                    retainTypeMedicine: true, typeMedicineName: this.state.searchWord
                })
            this.setState({
                searchedMeds: medicineList,
                showTypedMedicineName: !medicineList.length,
                showSearchingLoader: false
            })
        }
    }

    setSearchedWordList(searchWord, response) {
        if (searchWord.includes(response.searchWord) ||
            response.searchWord.includes(searchWord)) {
            let searchedWordList = response.suggestions
            this.setState({
                searchWordResult: searchedWordList,
                showTypedMedicineName: !searchedWordList.length,
                showSearchingLoader: false
            })
        }
    }

    handleSearchWordApiResponse(searchWord, response) {
        if (!response) {
            this.handleErrState(); return;
        }
        if (response.results)
            this.setSearchedMedcineList(searchWord, response)
        else if (response.suggestions)
            this.setSearchedWordList(searchWord, response)
        else this.setState({ showSearchingLoader: false })
    }

    handleErrState() {
        this.setState({ showSearchingLoader: false })
    }

    searchMedicine = async (searchWord) => {
        this.setState({ showSearchingLoader: true })
        let params = { searchWord: searchWord, origin: location.host }
        this.state.isLogined ?
            await omsDoPost('search/omg/medicine', params).
                then((response: any) => {
                    this.setSearchedMedcineList(searchWord, response)
                }, (err: any) => { this.handleErrState() }) :
            await omsDoPostGuest('omg_search_medicine', params).
                then((response: any) => {
                    this.setSearchedMedcineList(searchWord, response)
                }, (err: any) => { this.handleErrState() })
    }

    searchMedicineAPI = debounce(this.searchMedicine)

    onMedcineCategorySelect = (category) => {
        var list: any = [];
        list = [category]
        this.setState({ searchWord: category['searchTerm'], showTypedMedicineName: false })
        // if (this.state.prevSearchResult.length > 0) {
        //     if (!this.state.prevSearchResult.find((item: any) => item.name === category.name)) {
        //         // To show the lastest result at top.
        //         updateAutoCompleteSearchHistory(list.concat(this.state.prevSearchResult))
        //     }
        // } else {
        //     // To show the lastest result at top.
        //     updateAutoCompleteSearchHistory(list.concat(this.state.prevSearchResult))
        // }
        this.searchMedicineAPI(category['searchTerm'])

    }

    searchMedicineWords = async (searchWord) => {
        this.setState({ showSearchingLoader: true })
        let params = { searchWord: searchWord, origin: location.host }
        this.state.isLogined ?
            await omsDoPost('search/omg/autocomplete', params).
                then((response: any) => {
                    this.handleSearchWordApiResponse(searchWord, response)
                }, (err: any) => { this.handleErrState() }) :
            await omsDoPostGuest('omg_autocomplete', params).
                then((response: any) => {
                    this.handleSearchWordApiResponse(searchWord, response)
                }, (err: any) => { this.handleErrState() })
    }

    searchMedicineWordAPI = debounce((searchWord) => {
        this.searchMedicineWords(searchWord);
    }, AppTheme.searchDebounce)

    onChangeText(_searchWord) {
        this.setState({
            searchedMeds: [],
            searchWord: _searchWord,
            showTypedMedicineName: false
        })
        if (_searchWord.length > 2) {
            this.searchMedicineWordAPI(_searchWord)
        }
        // this.setState({
        //     searchWordResult: this.state.prevSearchResult,
        //     searchedMeds: []
        // })
    }

    updateCartItem(isAdd, item, quantity = 1) {
        upsertCartItem(isAdd, item, quantity, { typedQuantity: true })
    }

    cartNavigation = () => {
        this.setState({ searchedMeds: [], searchWord: '' })
        if (global.navigateFrom == NavigateFrom.cart_component_for_search_medicine) {
            global.navigateFrom = ''
            this.props?.navigation?.navigate(ScreenRoute.cart)
        } else this.props?.navigation?.navigate(ScreenRoute.review_oms_order)
    }


    showQuantityModal = (itemData) =>
        this.setState({ selectedProductData: itemData, showQtyModel: true })
    closeQuantityModal = () => { this.setState({ showQtyModel: false }) }

    showCartItemAddedToast = () => { this.setState({ showCartItemToast: true }) }
    closeCartItemAddedToast = () => { this.setState({ showCartItemToast: false }) }

    getToastBottomMargin = () => {
        let margin = 0
        if (getCartTotalItemCount() && this.showSearchMedicineList())
            margin = margin + AppTheme.estimatedPriceBarHeight
        return margin
    }

    showSearchMedicineList = () => {
        return !this.state.showSearchingLoader &&
            this.state.searchedMeds && this.state.searchedMeds.length > 0
    }

    showEstimatedPriceView() {
        return this.state?.searchWord?.length > 0 &&
            this.state.searchedMeds.length &&
            getCartTotalItemCount()
    }

    render() {
        return <View>

            <View style={[AppStyles.header, AppStyles.flexRowSpaceBetween,
            AppStyles.pr16, { paddingVertical: 6, justifyContent: 'flex-start' }]}>

                {CommonBackIcon({ navigation: this.props.navigation })}

                <Pressable onPress={() => {
                    MoengageUtils.trackMoengageEvents(
                        MoengageUtils.MoengageEvents.oms_order_started);
                }} style={[AppStyles.flexRowSpaceBetween, {
                    paddingVertical: 6, paddingHorizontal: 16,
                    width: AppTheme.appWidth - 112, backgroundColor: AppTheme.color.white
                }]}>
                    <View style={[AppStyles.flexRow]}>
                        <TextInput ref={this.props.inputRef}
                            style={[TextStyle.text14, {
                                color: AppTheme.color.grey.text, paddingHorizontal: 12,
                                width: AppTheme.appWidth - 113 - 68
                            }]}
                            autoFocus={true}
                            value={this.state.searchWord}
                            underlineColorAndroid="transparent"
                            placeholder={'Search medicines... '}
                            onChangeText={(text) => this.onChangeText(text)} />
                    </View>

                    {this.state.searchWord == '' ? null :
                        <CloseIcon resize={0.8}
                            action={() => this?.onChangeText('')} />}

                </Pressable>

                <CartIconView action={this.cartNavigation}
                    cartItemCount={getCartTotalItemCount()} />

            </View>

            <View style={{
                marginTop: AppTheme.headerHeight,
                paddingBottom: 16 + AppTheme.estimatedPriceBarHeight
            }}>

                {this.state.showSearchingLoader ?
                    <ActivityIndicator size="large" color={AppTheme.color.primary} /> : null}

                {this.showSearchMedicineList() ?
                    <FlatList keyExtractor={(item, index) => item?.mmid ?? index}
                        data={this.state.searchedMeds.
                            filter(meds => meds?.hasOwnProperty('name'))}
                        renderItem={({ item, index }) =>
                            <CartItemView item={item} showUnitPrice={true}
                                openAddQuantityModal={(itemData) =>
                                    this.showQuantityModal(itemData)}
                                updateCartItem={(isAdd, product) =>
                                    this.updateCartItem(isAdd, product)} />}
                        ItemSeparatorComponent={(item) => <HorizontalDivider width={AppTheme.appWidth} />}
                        renderToHardwareTextureAndroid /> : null}

                {this.state.showSearchingLoader || (this.state.searchedMeds && this.state.searchedMeds.length) ? null :
                    <FlatList keyExtractor={item => item['searchTerm']}
                        data={this.state.searchWordResult}
                        renderItem={({ item, index }) =>
                            <Pressable key={item['searchTerm']}
                                style={[AppStyles.flexRowSpaceBetween, {
                                    paddingHorizontal: 16, paddingVertical: 16, borderColor: '#d3d3d3',
                                    borderTopWidth: index == 0 ? 0 : 0.5
                                }]} onPress={() => { this.onMedcineCategorySelect(item) }} >
                                {AutoColorTypedStringView(index,
                                    this.state?.searchWord, item['searchTerm'])}
                                <Image style={{ marginRight: 8 }}
                                    source={{ uri: getImagePath('/images/icons/arrow_tilt_45.svg'), width: 13, height: 13 }} />
                            </Pressable>}
                        renderToHardwareTextureAndroid snapToAlignment="start" />}

                {this.state?.searchWord?.length > 0 &&
                    !this.state.showSearchingLoader &&
                    this.state.showTypedMedicineName ?
                    <Pressable onPress={() => {
                        this.setState({ showTypedMedicineName: false });
                        // TODO: confirm and enable it again
                        // this.searchMedicineAPI(this.state.searchWord);
                        this.showQuantityModal({ name: this.state.searchWord });
                    }}
                        style={[AppStyles.flexRowSpaceBetween, {
                            paddingHorizontal: 16, paddingVertical: 12, borderColor: '#d3d3d3',
                            borderTopWidth: this.state?.searchedMeds?.length ? 0.5 : 0
                        }]}>

                        <Text numberOfLines={1} ellipsizeMode={'head'}
                            style={[TextStyle.text16b, { letterSpacing: 0 }]}>
                            Add "{this.state.searchWord}"
                        </Text>
                        <Image style={{ marginRight: 8 }} source={{ uri: getImagePath('/images/icons/arrow_tilt_45.svg'), width: 13, height: 13 }} />
                    </Pressable>
                    : null
                }
            </View>

            {this.showEstimatedPriceView() ?
                <EstimatedPriceView ctaTitle={'View Cart'}
                    ctaAction={() => this.cartNavigation()}
                    cartTotalAmount={calculateCartAmount(this.state.cartItems)} /> : null}

            {this.state.showQtyModel && <CartQuantityInputBottomSheet
                showModal={this.state.showQtyModel}
                selectedProductData={this.state.selectedProductData}
                primaryAction={(product, quantity) => this.updateCartItem(true, product, quantity)}
                closeModal={() => this.closeQuantityModal()} />}

            {this.state.showCartItemToast && <AddCartItemToast
                closeToast={() => this.closeCartItemAddedToast()}
                showToast={this.state.showCartItemToast}
                bottomMargin={this.getToastBottomMargin()} />}
        </View >
    }

}
